// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"d86ba2e0","796":"54af05b6"}[chunkId] + ".chunk.js";
};